export const isInRoute = (route: string): boolean => window.location.href.includes(route);
